function createFormDataFileList (files) {
  if (!files?.length) return false

  const formData = new FormData()
  let count = 0

  for (const file of files) {
    if (file?.id) continue

    formData.append('files[]', file)
    count += 1
  }

  return count ? formData : false
}

export {
  createFormDataFileList
}
